import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.74 9.85A2.79 2.79 0 0 1 12 12.64H4.75a3.5 3.5 0 0 1-.41-7 4.1 4.1 0 0 1 6.08-2.24.75.75 0 1 1-.79 1.3 2.61 2.61 0 0 0-3.94 1.75s0 0 0 .06v.12a.74.74 0 0 1-.71.51H4.8a2 2 0 0 0-2 2 2 2 0 0 0 2 2H12a1.29 1.29 0 0 0 1.29-1.29A1.26 1.26 0 0 0 13 9a.75.75 0 1 1 1.16-.95 2.76 2.76 0 0 1 .58 1.8Zm-5.11-.19 4.89-4.9a.75.75 0 0 0-1.06-1.06L9.09 8.06 7.82 6.79a.75.75 0 0 0-1.07 1.06l1.81 1.81a.79.79 0 0 0 1.07 0Z';
const draw24px =
  'M7.59,9.8a.65.65,0,0,1,0,.2l0-.13A.19.19,0,0,1,7.59,9.8Zm13.1,2.1A.75.75,0,0,0,20,13.22a2.71,2.71,0,0,1-1.3,5.08H6.52a3.91,3.91,0,0,1,0-7.81h.27a.73.73,0,0,0,.3,0h0l.12-.06a.8.8,0,0,0,.17-.15l.08-.11L7.54,10l0-.13a.19.19,0,0,1,0-.07s0,0,0,0a4.93,4.93,0,0,1,8.09-2.82.75.75,0,0,0,1-1.12,6.45,6.45,0,0,0-4.25-1.6A6.37,6.37,0,0,0,6.23,9,5.4,5.4,0,0,0,6.52,19.8H18.67a4.21,4.21,0,0,0,2-7.9Zm-14-1.4h.12a.75.75,0,0,0,.26,0,.73.73,0,0,1-.3,0Zm6.39,5.28,8.5-8.5a.75.75,0,0,0-1.06-1.06l-8,8L10,11.58a.75.75,0,1,0-1.06,1.06L12,15.78a.73.73,0,0,0,.53.22A.74.74,0,0,0,13.1,15.78Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CloudCheckmarkIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'cloudCheckmark')) as IconWithRender;

CloudCheckmarkIcon.displayName = 'CloudCheckmarkIcon';
CloudCheckmarkIcon.propTypes = Icon.propTypes;
CloudCheckmarkIcon.renderIcon = (props) => <CloudCheckmarkIcon {...props} />;
export default CloudCheckmarkIcon;
